<template>
    <div>
        <main id="app">
            <div class="main-header-wrapper" v-if="showHeaderAndFooter">
                <MainHeader loginPath="/api/auth" logoutPath="/api/auth/logout" :userData="user" />
            </div>
            <router-view></router-view>
        </main>
        <MainFooter v-if="showHeaderAndFooter" />
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import MainHeader from "@bistudio/bohemia-vue-components-old/src/components/header/Header.vue";
import MainFooter from "@bistudio/bohemia-vue-components-old/src/components/footer/Footer.vue";

export default {
    name: "app",
    components: { MainHeader, MainFooter },
    watch: {
        $route: ["fetchUser"],
        user: function () {
            this.getNotifications();
        },
    },
    computed: {
        ...mapGetters("user", {
            user: "getUser",
            avatar: "getAvatar",
        }),
        showHeaderAndFooter: function () {
            return (
                this.$route.name.toLowerCase().indexOf("auth") < 0 &&
                this.$route.name.toLowerCase().indexOf("unsubscribe") < 0
            );
        },
    },
    methods: {
        ...mapActions("user", {
            getUserData: "getUserData",
        }),
        ...mapActions("config", {
            setIsLauncher: "setIsLauncher",
        }),
        fetchUser() {
            this.getUserData();
        },
        getNotifications() {
            this.services.NotificationResource.get().then((response) => {
                response.data.forEach((notification) => {
                    switch (notification.type) {
                        case "warning":
                            this.$toasted.error(notification.message, {
                                duration: 7000,
                            });
                            break;
                        case "success":
                            this.$toasted.success(notification.message, {
                                duration: 3000,
                            });
                            break;
                        default:
                            this.$toasted.info(notification.message, {
                                duration: 5000,
                            });
                    }
                });
            });
        },
    },
    created() {
        if (this.$route.query.client_id) {
            //TODO move to Login.vue
            this.services.AuthService.redirectBeforeLogin(this.$route.query);
        } else if (this.$route.name.toLowerCase().indexOf("logout") < 0) {
            this.fetchUser();

            window.addEventListener(
                "focus",
                (event) => {
                    this.fetchUser();
                },
                false
            );
        }
    },
};
</script>

<style lang="scss">
@import "./assets/scss/vars";

@font-face {
  font-family: Effra;
  weight: 700;
  src: url("./assets/fonts/Effra Bold.ttf");
}

@font-face {
  font-family: Effra;
  weight: 400;
  src: url("./assets/fonts/Effra Regular.ttf");
}

body {
    font-family: Effra, Helvetica, Arial, sans-serif;
    font-weight: 400;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: $black;
    font-size: 16px;
    text-align: center;
}

a {
    color: $gray8;
    text-decoration: none;

    &:hover {
        text-decoration: underline;
    }
}

p {
    line-height: 1.4em;
    margin-top: 0;
    margin-bottom: 1em;
    &:last-child {
        margin-bottom: 0;
    }
}

b {
    font-weight: bold;
}

button {
    background: none;
    border: none;
    outline: none;
}

.fade-enter-active,
.fade-leave-active {
    transition-property: opacity;
    transition-duration: 0.25s;
}

.fade-enter-active {
    transition-delay: 0.25s;
}

.fade-enter,
.fade-leave-active {
    opacity: 0;
}

/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-fade-enter-active {
    transition: all 0.2s ease;
}

.slide-fade-leave-active {
    transition: all 0.1s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter, .slide-fade-leave-to
        /* .slide-fade-leave-active below version 2.1.8 */ {
    transform: translateX(100px);
    opacity: 0;
}

#toasted-container .toasted.bubble {
    border-radius: 3px;
    font-weight: bold;
    color: $white;
    background: #ff7043;
    border: 1px solid #ff7043;

    &.toasted.bubble.success {
        border-color: #4caf50;
        background: #75dd8f;
    }

    &.toasted.bubble.info {
        border-color: #3f51b5;
        background: #7aaece;
    }

    &.toasted.bubble.error {
        border-color: #f44336;
        background: #ce7a8d;
    }
}

.shadowframe {
    box-shadow: rgba(0, 0, 0, 0.2) 1px 1px 4px 0px;
}

.whiteframe {
    color: #000;
    background-color: #ffffff;
}

.greyframe {
    color: #000;
    background-color: #f9f9f9;
}

::-webkit-scrollbar {
    $size: 0.3em;
    background-color: transparent;
    width: $size;
    height: $size;

    &:hover {
        background-color: rgba(0, 0, 0, 0.2);
    }
}

::-webkit-scrollbar-thumb:window-inactive,
::-webkit-scrollbar-thumb {
    background-color: rgba(255, 255, 255, 0.3);

    &:hover {
        background-color: rgba(255, 255, 255, 0.5);
    }
}

.darkframe {
    color: #fff;
    background-image: -webkit-radial-gradient(center, ellipse cover, #4c5463 44%, #2f2f2f 100%);

    .field-wrapper input,
    .field-wrapper select,
    .field-wrapper textarea {
        color: #000;
        background-color: #efefef;
    }
}

.transparent {
    color: #fff;
    background: transparent none !important;

    .field-wrapper input,
    .field-wrapper select,
    .field-wrapper textarea {
        color: #000;
        background-color: #efefef;
    }
}

.content-center-full-height {
    display: flex;
    flex: 1;
    flex-direction: column;
    align-items: center;
}

.list {
    list-style: none;
    padding: 0;
    margin: 0;
    text-align: center;

    &.list-inline {
        li {
            margin: 0 1em;
            display: inline-block;
        }
    }
}

.display-inline-block {
    display: inline-block;
}

.text-center {
    text-align: center;
}
</style>
<style scoped lang="scss">
#app {
    /*background-color: rgba(62, 71, 81, 0.9);*/
    background-color: transparent;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    overflow-x: hidden;
}
</style>
